import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/images/logo.png";

export default function Nav2() {
  const navigate = useNavigate();
  return (
    <div className="h-16 w-full flex justify-between items-center px-6">
      <div>
        <img src={logo} alt="mcare" className="h-6 w-24" />
        <h5 className="text-black font-semibold text-sm">Healthcare for All</h5>
      </div>

      <div className="md:flex justify-center items-center">
        {/* <p className="mx-4 text-sm lg:block hidden text-gray-600">
          hello@medpharma.care
        </p> */}
        <div className="flex">
          <Button
            size="middle"
            onClick={() => navigate("/sign-in")}
            className="mx-4"
          >
            Login
          </Button>
          <Button
            size="middle"
            onClick={() => navigate("/sign-up")}
            className="bg-[#1A94EC] text-white hover:text-[#1A94EC]"
          >
            Register
          </Button>
        </div>
      </div>
    </div>
  );
}
